import { emitSessionExpired } from "@/lib/auth-events";

const AUTH_BYPASS_PREFIXES = ["/api/auth/"];

function isAuthEndpoint(input: RequestInfo | URL): boolean {
  const url = input instanceof Request ? input.url : String(input);
  // Use a dummy base so relative paths resolve correctly in both browser and SSR.
  // For absolute URLs the base is ignored, so http://host/api/auth/x still resolves
  // to pathname /api/auth/x rather than the full URL string.
  const base =
    typeof window !== "undefined" ? window.location.origin : "http://localhost";
  const { pathname } = new URL(url, base);
  return AUTH_BYPASS_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export async function customFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const response = await fetch(input, init);

  if (response.status === 401 && !isAuthEndpoint(input)) {
    emitSessionExpired("API returned 401", 401);
  }

  return response;
}
